<template>
  <div id="app" class="d-flex flex-column h-100">
    <notifications
      group="notification"
      position="top center"
      class="notification shadow-lg mt-5"
    >
      <template slot="body" slot-scope="props">
        <div class="text-center p-2">
          <a class="title">{{ props.item.title }}</a>
          <a class="close" @click="props.close">
            <base-icon icon_name="x-circle" />
          </a>
          <div v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>

    <notifications
      group="order"
      position="bottom right"
      class="notification-order mb-4"
      @click.native="openOrders()"
    >
      <template slot="body" slot-scope="props">
        <div class="p-2">
          <a class="title">{{ props.item.title }}</a>
          <a class="close" @click="props.close">
            <base-icon icon_name="x-circle" />
          </a>
          <div v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>
    <main class="flex-shrink-0" style="margin-bottom: 20px;">
      <transition name="slide-fade" mode="out-in">
        <component v-if="layout" :is="layout" />
      </transition>
    </main>
    <footer-app/>
  </div>
</template>  
<script>
const requireContext = require.context("./layouts", false, /.*\.vue$/);
const layouts = requireContext
  .keys()
  .map((file) => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

import store from "@/store";
const fb = require("@/firebase/config.js");
export default {
  name: "App",
  components: {},
  data: () => ({
    layout: null,
    defaultLayout: "default",
  }),
  computed: {
    user() {
      let user = store.getters["auth/user"];
      return user;
    },
    redirect() {
      let user = store.getters["auth/redirect"];
      return user;
    },
  }, 
  mounted() {
    this.firestore();

    // correct old data
    if(this.user && !this.user.id){
      this.$store.dispatch('auth/clearUser')
    }

  },
  methods: {
    async firestore() {
      await store.dispatch("auth/firebaseState", false);
      await store.dispatch("auth/firestore_init");
    },
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }
      this.layout = layouts[layout];
    },
    openOrders() {
      this.$router.push({ name: "orders" }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.notification {
  color: black;
  border-radius: 6px;
  background: #fff025;
  margin-top: 10px;
}
.notification-order {
  color: #f2f4ef;
  border-radius: 6px;
  background: #3f9b3f;
  margin-top: 10px;
  // border: 1px solid lightgray;
}
</style>

 